import React from "react"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import {
	ContentHubArticlePageBlockProps,
} from "../ContentHubArticlePageBlock"
import { ContentLink } from "../../@types/CapioWeb/core"
import { ArticleList } from './components/ArticleList'
import { ArticleFilterContextProvider } from './context/ArticleFilterContext'
import { ArticleFilter } from './components/ArticleFilter'
import { BlockCommonLayout } from '../../utils/layout'

interface ContentHubArticleListingBlockProps {
	heading: StringProperty
	contentLink: ContentLink
	articles: Articles
}

export interface Articles {
	filters: ArticlesFilterValue[]
	items: ContentHubArticlePageBlockProps[]
	skip: number
	take: number
	totalItems: number
}

export interface ArticlesFilterValue {
	key: string
	value: ArticleFilterValue[]
}
export interface ArticleFilterValue {
	id: string
	name: string
	hits?: number
}


const ContentHubArticleListingBlock: React.FC<ContentHubArticleListingBlockProps> =
	({ heading, articles }) => {


		return (
			<BlockCommonLayout heading={heading}>
				<ArticleFilterContextProvider>
					<ArticleFilter articles={articles} />
					<ArticleList articles={articles} />
				</ArticleFilterContextProvider>
			</BlockCommonLayout>
		)
	}

export { ContentHubArticleListingBlock }
